import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { BsArrowRight, BsCheckCircle } from 'react-icons/bs';
import { LinkContainer } from 'react-router-bootstrap';
import { useParams } from 'react-router-dom';

import { AuthService, VerifyEmail as VerifyEmailModel } from '../api';
import { Logo } from '../app/components/Logo';
import { useDocumentTitle } from '../app/hooks/use-document-title';

export const VerifyEmail = () => {
  useDocumentTitle('Email Confirmation');
  const { key } = useParams();

  const mutationVerifyEmail = useMutation({
    mutationFn: async (data: VerifyEmailModel) => {
      await AuthService.authRegistrationVerifyEmailCreate({
        requestBody: data,
      });
    },
  });

  useEffect(() => {
    if (key) {
      mutationVerifyEmail.mutateAsync({ key });
    }
  }, [key]);

  const loadingState = (
    <div className="text-center">
      <h2 className="mb-4">Loading...</h2>
    </div>
  );

  const errorState = (
    <div className="text-center text-danger">
      <h2 className="mb-4">Something went wrong!</h2>
      <p>
        The verification link may be expired or your email may be confirmed already.
        <br />
        Please try logging in again.
      </p>
      <LinkContainer to="/login">
        <Button variant="primary" size="lg">
          Go to Login
        </Button>
      </LinkContainer>
    </div>
  );

  const successText = (
    <div className="text-center">
      <BsCheckCircle size="48px" className="mb-4 mx-auto color-primary" />
      <h2 className="mb-4">Your email is confirmed!</h2>
      <LinkContainer to="/login">
        <Button
          className="d-flex align-items-center justify-content-center"
          variant="primary"
          size="lg"
        >
          Continue to Login <BsArrowRight className="ms-2" />
        </Button>
      </LinkContainer>
    </div>
  );

  let currentState = loadingState;
  if (mutationVerifyEmail.isSuccess) currentState = successText;
  if (mutationVerifyEmail.isError) currentState = errorState;

  return (
    <div className="login-bg-container">
      <Container>
        <Card>
          <Card.Body>
            <div className="logo-container">
              <Logo className="logo" variant="color" />
            </div>
            {currentState}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};
